import { useState, useEffect } from 'react';
import SearchIcon from '@assets/images/mobile_searchIcon.png';
import styles from './index.module.scss';
import cs from 'classnames';
import {
  Col,
  EmptyStory,
  Flex,
  InputCore,
  Loading,
  Row,
  Tag,
  ToggleStory,
} from '@components';
import { BiSearchAlt } from 'react-icons/bi';
import MobileStoryCard from './StoryCard';
import { useGetHashtagList, useGetStories } from '@coreStory/useCase';
import { IStoryList } from '@coreStory/type';

type Stories = 'userPrivateStories' | 'userPublicStories';
const MobileLibrary = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [searchMode, setSearchMode] = useState<boolean>(false);
  const [storyType, setStoryType] = useState<Stories>('userPrivateStories');
  const [storyHashtagAvtice, setStoryHashtagAvtice] = useState<any>();
  const [storiesData, setStoriesData] = useState<IStoryList[]>();
  const [filteredStories, setFilteredStories] = useState<IStoryList[]>([]);

  const getUserStory = useGetStories();
  const getUserHashtag = useGetHashtagList();

  useEffect(() => {
    getUserStory.mutate({ public: false, hashtagid: 0 });
    getUserHashtag.mutate({ public: false });
  }, []);

  const handleGetUserStory = () => {
    getUserStory.mutate({ public: false, hashtagid: 0 });
  };
  useEffect(() => {
    handleGetUserStory();
  }, []);

  useEffect(() => {
    setStoryHashtagAvtice(0);
  }, [storyType]);

  useEffect(() => {
    if (getUserStory.data) {
      if (storyType === 'userPrivateStories') {
        setStoriesData(
          getUserStory?.data.filter((item) => item.IsPrivate === true),
        );
      } else {
        setStoriesData(
          getUserStory?.data.filter((item) => item.IsPrivate === false),
        );
      }
    }
  }, [storyType, getUserStory.data]);

  useEffect(() => {
    if (getUserStory.isLoading) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [getUserStory.isLoading]);

  const filterData = (data: IStoryList[], filterValue = ''): IStoryList[] => {
    return data.filter(
      (story) =>
        story?.StoryText?.toLowerCase().trim().includes(filterValue) ||
        story?.StoryName?.toLowerCase().trim().includes(filterValue),
    );
  };

  const handleInput = (event: React.FormEvent<HTMLInputElement>) => {
    const text = event.currentTarget.value.toLowerCase().trim();
    if (text.length >= 3) {
      setSearchMode(true);
      storiesData && setFilteredStories(filterData(storiesData, text));
    } else if (!text) {
      setSearchMode(false);
      storiesData && setFilteredStories(storiesData);
    }
  };
  const handleStoryHashtag = (id: any) => {
    setStoryHashtagAvtice(id);
    getUserStory.mutate({ public: false, hashtagid: id });
  };

  return (
    <div>
      <div className={styles['top_box']}>
        <div className={styles['title_box']}>
          <img src={SearchIcon} alt="search" />
          <h2>My Library</h2>
        </div>
        {/* <div className={styles['toggle']}>
          <ToggleStory />
        </div> */}
      </div>
      <div className={cs([styles['stories_filters'], 'mobile_story_filters'])}>
        <div
          onClick={() => setStoryType('userPrivateStories')}
          className={cs([
            styles['filter_btn'],
            storyType === 'userPrivateStories' ? styles['active'] : '',
          ])}>
          <span>My Private Stories</span>
        </div>
        <div
          onClick={() => setStoryType('userPublicStories')}
          className={cs([
            styles['filter_btn'],
            storyType === 'userPublicStories' ? styles['active'] : '',
          ])}>
          <span>My Public Stories</span>
        </div>
      </div>
      <div className={styles['stories_container']}>
        <div className={styles['search_box']}>
          <InputCore
            placeholder="search"
            suffix={<BiSearchAlt />}
            className={styles['input']}
            onInput={(e) => handleInput(e)}
          />
        </div>
        {getUserHashtag.data && (
          <Flex
            style={{
              maxWidth: '100%',
              overflowX: 'auto',
              paddingBottom: 5,
              marginBottom: 20,
            }}>
            <Tag
              style={{
                borderColor: '#8A8181',
                cursor: 'pointer',
                color: storyHashtagAvtice === 0 ? '#fff' : '#8A8181',
                borderRadius: 50,
                background:
                  storyHashtagAvtice === 0 ? '#8A8181' : 'transparent',
              }}
              onClick={() => handleStoryHashtag(0)}>
              #All
            </Tag>
            {getUserHashtag.data.map((item) => (
              <Tag
                key={item.HashtagID}
                style={{
                  borderColor: '#8A8181',
                  cursor: 'pointer',
                  color:
                    storyHashtagAvtice === item.HashtagID ? '#fff' : '#8A8181',
                  borderRadius: 50,
                  background:
                    storyHashtagAvtice === item.HashtagID
                      ? '#8A8181'
                      : 'transparent',
                }}
                onClick={() => handleStoryHashtag(item.HashtagID)}>
                #{item.Hashtag}
              </Tag>
            ))}
          </Flex>
        )}
        <Row gutter={[0, 20]}>
          {isLoading ? (
            <Loading />
          ) : searchMode ? (
            filteredStories.length ? (
              filteredStories.map((item, index) => {
                return (
                  <Col key={index} xs={24}>
                    <MobileStoryCard {...item} />
                  </Col>
                );
              })
            ) : (
              <EmptyStory />
            )
          ) : storiesData?.length ? (
            storiesData?.map((item, index) => {
              return (
                <Col key={index} xs={24}>
                  <MobileStoryCard {...item} />
                </Col>
              );
            })
          ) : (
            <EmptyStory />
          )}
        </Row>
      </div>
    </div>
  );
};

export default MobileLibrary;
